/** @jsx jsx */

import { ComponentProps } from 'react';

import { TagLabel } from '@zapier/design-system';
import { jsx } from '@emotion/core';

import {
  APP_STATUSES_DISPLAY_NAME,
  VersionStatus,
} from 'app/developer-v3/constants';

type Props = {
  color: ComponentProps<typeof TagLabel>['color'];
  label: APP_STATUSES_DISPLAY_NAME | VersionStatus | string;
  size?: ComponentProps<typeof TagLabel>['size'];
};

const defaultProps = {
  size: 'medium' as const,
};

function StatusLabel({ color, label, size = defaultProps.size }: Props) {
  return (
    <TagLabel color={color} size={size}>
      {label}
    </TagLabel>
  );
}

export default StatusLabel;
